export const FUSION_LOGO_APP = `https://s3.amazonaws.com/static.paperlessparts.com/images/fusion-icon.png`;
export const FUSION_BANNER =
  'https://s3.amazonaws.com/static.paperlessparts.com/images/fusion-app-header-slim.png';
export const FUSION_LOGO_FULL =
  'https://s3.amazonaws.com/static.paperlessparts.com/images/fusion-logo-full-name.png';
export const FUSION_LOGO_FULL_WHITE =
  'https://s3.amazonaws.com/static.paperlessparts.com/images/fusion-splash-logo-white.png';
export const FUSION_SPLASH_BANNER =
  'https://s3.amazonaws.com/static.paperlessparts.com/images/fusion-splash-banner.png';

export const TRY_FUSION_URL = 'https://autode.sk/3DTbH8q';
export const FUSION_LEARN_MORE_URL =
  'https://help.paperlessparts.com/s/article/autodesk-fusion-integration';

export const FUSION_INTEGRATION_DEFAULTS = {
  NAME: 'Autodesk Fusion',
  AUTHOR: 'Paperless Parts',
  DESCRIPTION: 'Move part files between Autodesk Fusion and Paperless Parts',
  IMAGE: FUSION_LOGO_FULL,
  INTERNAL_PRODUCTIZED_NAME: 'Fusion Teams',
  CATEGORY: 'other',
  KEY: 'fusion',
} as const;
